import "./topNav.css";

import React from "react";
import { Link } from "react-router-dom";
import { Button, IconButton, Drawer } from "@material-ui/core";
import { Menu as MenuIcon, Close, Facebook, Instagram } from "@material-ui/icons";

import { PAGE_ROUTES } from "../../utils/stateTypes";

// Material UI styles
const styles = {
  menuButton: {
    marginRight: "10px",
  },
  menuFeaturedButton: {
    color: "rgb(124, 124, 124)",
  },

  drawerClose: {
    position: "absolute",
    top: "10px",
    right: "10px",
  },
  drawerButton: {
    width: "100%",
    padding: "15px",
  },
  socialIcon: {
    width: 20,
    height: 20,
    color: "#333",
  },
  socialButton: {
    marginRight: 3,
  },
};

//Set up a function to update isScrolled when scrolling
const handleScroll = (setIsScrolled) => (
  () => {
    const scrolled = window.scrollY > 50;
    setIsScrolled(scrolled);
  }
);


const TopNav = () => {
  const [showDrawer, setShowDrawer] = React.useState(false);
  const closeDrawer = React.useCallback(() => {
    setShowDrawer(false);
  }, []);
  const openDrawer = React.useCallback(() => setShowDrawer(true), []);

  const [isScrolled, setIsScrolled] = React.useState(false);
  React.useEffect(() => {
    let checkIsScrolledFn = setInterval(handleScroll(setIsScrolled), 100);
    return () => {
      clearInterval(checkIsScrolledFn);
    };
  }, []);


  return (
    <nav className={`menu-top ${isScrolled ? "scrolled" : ""}`}>
      <div className={"menu-top-inner standard-width"}>
        <Link
          to={PAGE_ROUTES.HOME}
          className={"menu-top-logo"}
        >
          <img
            src={"/images/logo-2.webp"}
            className={"menu-top-logo-img"}
            alt={"Ash The Dietitian Logo"}
          />
        </Link>
        
        <div className={"menu-top-links"}>
          <Link
            to={PAGE_ROUTES.HOME}
            className={"menu-top-button"}
          >
            <Button
              variant={"text"}
              style={styles.menuButton}
            >
              Home
            </Button>
          </Link>
          <Link
            to={PAGE_ROUTES.SERVICES}
            className={"menu-top-button"}
          >
            <Button
              variant={"text"}
              style={styles.menuButton}
            >
              Services
            </Button>
          </Link>
          <Link
            to={PAGE_ROUTES.CORPORATE}
            className={"menu-top-button"}
          >
            <Button
              variant={"text"}
              style={styles.menuButton}
            >
              Corporate
            </Button>
          </Link>
          <Link
            to={PAGE_ROUTES.STORE}
            className={"menu-top-button"}
          >
            <Button
              variant={"text"}
              style={styles.menuButton}
            >
              Store
            </Button>
          </Link>
          <Link
            to={PAGE_ROUTES.CONTACT}
            className={"menu-top-button"}
          >
            <Button
              variant={"text"}
              style={styles.menuButton}
            >
              Contact
            </Button>
          </Link>
          <Link
            to={PAGE_ROUTES.BOOK}
            className={"menu-top-button"}
          >
            <Button
              variant={"outlined"}
              style={styles.menuButton}
            >
              Book a consultation
            </Button>
          </Link>
          <IconButton
            href={"https://web.facebook.com/ashthedietitian/"}
            target={"_blank"}
            style={styles.socialButton}
            size={"small"}
          >
            <Facebook style={styles.socialIcon} />
          </IconButton>
          <IconButton
            href={"https://www.instagram.com/ashthedietitian/"}
            target={"_blank"}
            style={styles.socialButton}
            size={"small"}
          >
            <Instagram style={styles.socialIcon} />
          </IconButton>
        </div>

        {/* =================== MOBILE MENU =================== */}
        <span className={"mobile-menu-toggle"}>
          <IconButton
            onClick={openDrawer}
            color={"secondary"}
          >
            <MenuIcon />
          </IconButton>
        </span>
      </div>

      <Drawer
        anchor={"right"}
        open={showDrawer}
        onClose={closeDrawer}
        disableScrollLock={true}
      >
        <div className={"drawer-inner"}>
          <IconButton
            onClick={closeDrawer} 
            style={styles.drawerClose}
            color={"secondary"}
          >
            <Close />
          </IconButton>
          
          <div>
            <Link to={PAGE_ROUTES.HOME}>
              <Button
                variant={"text"}
                color={"secondary"}
                size={"large"}
                style={styles.drawerButton}
                onClick={closeDrawer}
              >
                Home
              </Button>
            </Link>
            <Link to={PAGE_ROUTES.SERVICES}>
              <Button
                variant={"text"}
                color={"secondary"}
                size={"large"}
                style={styles.drawerButton}
                onClick={closeDrawer}
              >
                Services
              </Button>
            </Link>
            <Link to={PAGE_ROUTES.CORPORATE}>
              <Button
                variant={"text"}
                color={"secondary"}
                size={"large"}
                style={styles.drawerButton}
                onClick={closeDrawer}
              >
                Corporate
              </Button>
            </Link>
            <Link to={PAGE_ROUTES.STORE}>
              <Button
                variant={"text"}
                color={"secondary"}
                size={"large"}
                style={styles.drawerButton}
                onClick={closeDrawer}
              >
                Store
              </Button>
            </Link>
            <Link to={PAGE_ROUTES.CONTACT}>
              <Button
                variant={"text"}
                color={"secondary"}
                size={"large"}
                style={styles.drawerButton}
                onClick={closeDrawer}
              >
                Contact
              </Button>
            </Link>
            <Link to={PAGE_ROUTES.BOOK}>
              <Button
                variant={"text"}
                color={"secondary"}
                size={"large"}
                style={styles.drawerButton}
                onClick={closeDrawer}
              >
                Book a consultation
              </Button>
            </Link>
          </div>

          <div className={"mobile-menu-bottom"}>
            <div className={"mobile-menu-socials"}>
              <IconButton
                href={"https://web.facebook.com/ashthedietitian/"}
                target={"_blank"}
                color={"secondary"}
                style={styles.socialButton}
                aria-label={"Facebook"}
              >
                <Facebook style={styles.socialIcon} />
              </IconButton>
              <IconButton
                href={"https://www.instagram.com/ashthedietitian/"}
                target={"_blank"}
                color={"secondary"}
                style={styles.socialButton}
                aria-label={"Instagram"}
              >
                <Instagram style={styles.socialIcon} />
              </IconButton>
            </div>
            <img
              className={"drawer-menu-logo"}
              src={"/images/logo-1.webp"}
              alt={"Ash The Dietitian Logo"}
            />
          </div>
        </div>
      </Drawer>
    </nav>
  );
};

export default TopNav;
